import React from "react";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

// Invoice summary from the canonical stored invoice (same values as the PDF/email).
export const InvoiceSummaryTotals = ({ invoice, totals, isUsa }) => {
  const has = (k) => invoice && invoice[k] !== undefined && invoice[k] !== null;
  const subtotal = has("subtotal") ? invoice.subtotal : totals.amount;
  const tax = has("tax_amount") ? invoice.tax_amount : totals.gst + totals.pst;
  const total = has("total") ? invoice.total : totals.finalAmount;
  const sc = invoice?.service_charge;
  const disc = invoice?.discount;
  return (
    <table className="gf-table" style={{ maxWidth: 380 }} data-testid="invoice-summary-table">
      <tbody>
        <tr><td className="text-right font-mono">SUBTOTAL</td><td className="gf-num" data-testid="invoice-summary-subtotal">{money(subtotal)}</td></tr>
        <tr><td className="text-right font-mono">TOTAL TAX{isUsa ? " (USA — included in pump price)" : ""}</td><td className="gf-num" data-testid="invoice-summary-tax">{money(tax)}</td></tr>
        {Number(sc?.amount) > 0 && (
          <tr><td className="text-right font-mono">SERVICE CHARGE{Number(sc.tax_amount) > 0 ? " (incl. tax)" : ""}</td><td className="gf-num" data-testid="invoice-summary-service-charge">{money(Number(sc.amount) + Number(sc.tax_amount || 0))}</td></tr>
        )}
        {Number(disc?.amount) > 0 && (
          <tr><td className="text-right font-mono">DISCOUNT{disc.description ? ` · ${disc.description}` : ""}</td><td className="gf-num" data-testid="invoice-summary-discount">-{money(disc.amount)}</td></tr>
        )}
        <tr style={{ background: "#09090B" }}>
          <td className="text-right font-mono font-bold" style={{ color: "#fff" }}>TOTAL DUE</td>
          <td className="gf-num font-bold text-base" style={{ color: "#fff" }} data-testid="invoice-summary-total-due">{money(total)}</td>
        </tr>
      </tbody>
    </table>
  );
};
